<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>
        <div class="row" v-if="!loading && getFriends(false).length">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-user-plus"></i> Zaproszenia do grona znajomych
                    </div>
                    <div class="card-body">
                        <data-table
                            :fields="fieldsRequests"
                            :items="getFriends(false)"
                        >
                            <template v-slot:invoker="row">
                                <client :client="row.value.dbid == user.clientDbid ? row.item.recipient : row.value" withAvatar/>
                            </template>
                            <template v-slot:created_at="row">
                                {{ row.value | moment("DD-MM-YYYY HH:mm")}}
                            </template>
                            <template v-slot:accepted="row">
                                <span v-if="row.item.invoker_dbid == user.clientDbid" class="badge badge-primary p-2"><i class="fa fa-sync"></i> Oczekuje na zatwierdzenie przez drugiego użytkownika</span>
                                <span v-else class="badge badge-primary p-2"><i class="fa fa-handshake"></i> Do akceptacji przez Ciebie</span>
                            </template>
                            <template v-slot:id="row">
                                <div v-if="row.item.invoker_dbid == user.clientDbid">
                                    ---
                                </div>
                                <div v-else>
                                    <button class="btn btn-primary m-1" @click="acceptFriend(row.item.id)"><i class="fa fa-check"></i> Akceptuj</button>
                                    <button class="btn btn-danger m-1" @click="rejectFriend(row.item.id)"><i class="fa fa-times"></i> Odrzuć</button>
                                </div>
                            </template>
                        </data-table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="!loading">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-users"></i> Twoi znajomi
                    </div>
                    <div class="card-body">
                        <data-table
                            v-if="getFriends(true).length"
                            :fields="fieldsFriends"
                            :items="getFriends(true)"
                            delete
                            v-on:delete="deleteFriend"
                        >
                            <template v-slot:invoker="row">
                                <client :client="row.value.dbid == user.clientDbid ? row.item.recipient : row.value" withAvatar/>
                            </template>
                            <template v-slot:updated_at="row">
                                {{ row.value | moment("DD-MM-YYYY HH:mm")}}
                            </template>
                        </data-table>
                        <div v-else>
                            <h5>Nie masz jeszcze żadnych znajomych. Zaproś kogoś do grona znajomych już teraz!</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import FriendsService from "@/services/friends.service";
import {
    notificationMethods
} from "@/state/helpers";

/**
 * Starter component
 */
export default {
    name: "Groups",
    components: {Layout, PageHeader},
    data() {
        return {
            title: "Znajomi",
            items: [
                {
                    text: "Konto",
                    href: "/"
                },
                {
                    text: "Znajomi",
                    active: true
                }
            ],
            fieldsFriends: [
                {key: "invoker", label: "Użytkownik"},
                {key: "updated_at", label: "Znajomi od"},
            ],
            fieldsRequests: [
                {key: "invoker", label: "Użytkownik"},
                {key: "created_at", label: "Data wysłania zaproszenia"},
                {key: "accepted", label: "Status"},
                {key: "id", label: "Opcje"},
            ],
            loading: true,
            data: {}
        };
    },
    computed: {
        user() {
            return this.$store.getters['auth/user'];
        },
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ... notificationMethods,
        loadData() {
            FriendsService.getFriends(this.user.clientDbid).then(
                response => {
                    this.data = response.data;
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        getFriends(accepted) {
            return this.data.filter(d => d.accepted == accepted);
        },
        deleteFriend(friend) {
            this.loading = true;
            
            FriendsService.delete(friend.id).then(
                () => {
                    this.success("Użytkownik został usunięty z grona znajomych");
                    this.loadData();
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        acceptFriend(id) {
            this.loading = true;
        
            FriendsService.accept(id).then(
                () => {
                    this.success("Zaproszenie zostało zaakceptowane");
                    this.loadData();
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        rejectFriend(id) {
            this.loading = true;
        
            FriendsService.delete(id).then(
                () => {
                    this.success("Zaproszenie zostało odrzucone");
                    this.loadData();
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
    }
};
</script>